export enum ErrorType {
    EXPIRED = "expired",
    MAX_ATTEMPTS = "max_attempts",
    CANCELED = "canceled",
    UNKNOWN_ERROR = "unknown",
    CANCELLED = "cancelled",
    SIGNED = "signed",
    UNKNOWN_ERROR_GALEON = "error"
}
export enum ErrorTypeCommon {
    ESG0014 = "ESG0014",
    ESG0015 = "ESG0015",
    ESG0016 = "ESG0016",
    UNKNOWN_ERROR = "Unknown"
}

export enum ErrorMessage {
    ESG0014 = "Pin incorrecto",
    ESG0015 = "Pin expirado",
    ESG0016 = "Número máximo de reintentos alcanzado",
    UNKNOWN_ERROR = "Error desconocido"
}

export enum StatusType {
    ERR = 'ERR',
    CAN = 'CAN',
    ANU = 'ANU',
    SGN = 'SGN',
    INI = 'INI',
    PRO = 'PRO'
}